export function formatErrors(errors) {
  const errorsMap = {};
  errors.forEach((e) => {
    errorsMap[e.field] = e.messages;
  });
  return errorsMap;
}

export function serializeFormData(formData) {
  return formData;
  // const resultData = {};
  // for (const [key, value] of Object.entries(formData)) {
  //   if (value === null) {
  //     resultData[key] = null;
  //   } else if (value === undefined) {
  //     resultData[key] = null;
  //   } else if (typeof value === 'object') {
  //     resultData[key] = value.id;
  //   } else {
  //     resultData[key] = value;
  //   }
  // }
  // return resultData;
}
